import styled from 'styled-components';

export const Container = styled.div``;

export const SlidersList = styled.div`
  width: 119%;
  position: relative;
  left: calc(9% * -1 - 4px);
`;
